import { ParameterItem } from './parameter-item';
import { ParamGroupItem } from './param-group-item';

export class ParametersConfig {
    parameters: ParameterItem[];
    resultsValidated: boolean;
    getData: (group: ParamGroupItem) => void;
}
